import Api from 'api'

const config = { baseURL: '/api/app/v1/agency' }

const api = new Api(config)

api.fetchInfo = () => api.get('')

api.create = ({ ...rest }) => api.post('', { ...rest })

api.fetchClients = ({ ...rest }) => api.get('/clients', { ...rest })

api.archiveClients = ({ ...rest }) => api.post('/clients/archive', { ...rest })

api.activateClients = ({ ...rest }) =>
  api.post('/clients/activate', { ...rest })

api.fetchClientAccounts = ({ id, ...rest }) =>
  api.get(`/clients/${id}/accounts`, { ...rest })

api.setPriority = ({ ...rest }) => api.post('/clients/priority', { ...rest })

api.fetchRequests = ({ ...rest }) => api.get('/requests', { ...rest })

api.addRequest = ({ ...rest }) => api.post('/requests', { ...rest })

api.deleteRequest = ({ id }) => api.delete(`/requests/${id}`)

api.renameClient = ({ id, ...rest }) =>
  api.put(`/clients/${id}/name`, { ...rest })

export default api
